import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _styled from "@emotion/styled/base";
var _excluded = ["children", "size", "elevation", "tokens"],
    _excluded2 = ["children", "tokens"],
    _excluded3 = ["children", "tokens"],
    _excluded4 = ["children", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { forwardRef } from 'react';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './EventItem.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var BaseEventItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "large" : _ref$size,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 2 : _ref$elevation,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.EventItem, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    size: size,
    elevation: elevation
  }, tokens), rest), {}, {
    children: children
  }));
});
export var EventItem = withDesignTokens(BaseEventItem, function (_ref2, theme) {
  var _ref2$textAlign = _ref2.textAlign,
      textAlign = _ref2$textAlign === void 0 ? "left" : _ref2$textAlign,
      background = _ref2.background;
  return {
    textAlign: textAlign,
    backgroundColor: background !== null && background !== void 0 ? background : theme.palette.neutrals.white[100]
  };
}, {
  light: function light() {
    return {};
  },
  dark: function dark() {
    return {};
  },
  twilioLight: function twilioLight() {
    return {};
  }
}); // Compound Components

var BaseIcon = /*#__PURE__*/forwardRef(function (_ref3, ref) {
  var children = _ref3.children,
      tokens = _ref3.tokens;
  return _jsx(views.Icon, {
    ref: ref,
    variant: "circle",
    tokens: tokens,
    children: children
  });
});
export var Icon = withDesignTokens(BaseIcon, function (_, theme) {
  return {
    backgroundColor: theme.palette.neutrals.white[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var BaseCode = /*#__PURE__*/forwardRef(function (_ref4, ref) {
  var children = _ref4.children,
      tokens = _ref4.tokens,
      rest = _objectWithoutProperties(_ref4, _excluded2);

  return _jsx(views.Code, _objectSpread(_objectSpread({
    ref: ref,
    variant: "code"
  }, rest), {}, {
    tokens: tokens,
    children: children
  }));
});
export var Code = withDesignTokens(BaseCode, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.boysenberry[500]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.boysenberry[500]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.boysenberry[60]
    };
  }
});
var BaseEventItemLabel = /*#__PURE__*/forwardRef(function (_ref5, ref) {
  var children = _ref5.children,
      tokens = _ref5.tokens,
      rest = _objectWithoutProperties(_ref5, _excluded3);

  return _jsx(views.Label, _objectSpread(_objectSpread({
    ref: ref,
    variant: "buttonSmall",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
export var Label = withDesignTokens(BaseEventItemLabel, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100]
    };
  }
});
var BaseDetail = /*#__PURE__*/forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
      tokens = _ref6.tokens,
      rest = _objectWithoutProperties(_ref6, _excluded4);

  return _jsx(views.Detail, _objectSpread(_objectSpread({
    ref: ref,
    variant: "textTiny",
    tokens: tokens
  }, rest), {}, {
    children: children
  }));
});
export var Detail = withDesignTokens(BaseDetail, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[400]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[40]
    };
  }
});
export var Body = /*#__PURE__*/_styled("div", true ? {
  target: "e1r4jbxh0"
} : {
  target: "e1r4jbxh0",
  label: "Body"
})(true ? {
  name: "m5ao3r",
  styles: "grid-area:body;display:grid;grid-gap:2px"
} : {
  name: "m5ao3r",
  styles: "grid-area:body;display:grid;grid-gap:2px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});